import React from 'react';

const WhyChoose = () => {
  return (
    <div className="why-choose-area pd-bottom-120">
      <div className="container">
        <div className="section-title mt-4 mt-lg-0">
          <div className="row">
            <div className="col-lg-4">
              <h6 className="color-base bg-none mb-3">Why choose us?</h6>
              <h2 className="title">Get quality leads in single click</h2>
            </div>
            <div className="col-xl-7 col-lg-8 offset-xl-1 align-self-end">
              <p className="content">
                It is a long established fact that a reader will be distracted
                by the readable content of a page when is looking at its
                layoutthe readable content of a page when looking at its
                layout.It is a long established fact that a reader will be
                distracted by the readable content of a page whe
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-7 col-lg-6 col-md-8 order-lg-last">
            <img src="assets/img/home-7/5.png" alt="img" />
          </div>
          <div className="col-xl-5 col-lg-6 align-self-center align-self-center">
            <div className="why-choose-us-list mb-3 mt-4 mt-lg-0">
              <div className="media">
                <h4 className="count">01</h4>
                <div className="media-left me-4 align-self-center">
                  <img src="assets/img/home-7/7.png" alt="img" />
                </div>
                <div className="media-body">
                  <h4>First Working Process</h4>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p>
                </div>
              </div>
            </div>
            <div className="why-choose-us-list mb-3">
              <div className="media">
                <h4 className="count color-base">01</h4>
                <div className="media-left me-4 align-self-center">
                  <img src="assets/img/home-7/7.png" alt="img" />
                </div>
                <div className="media-body">
                  <h4>First Working Process</h4>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p>
                </div>
              </div>
            </div>
            <div className="why-choose-us-list">
              <div className="media">
                <h4 className="count">01</h4>
                <div className="media-left me-4 align-self-center">
                  <img src="assets/img/home-7/7.png" alt="img" />
                </div>
                <div className="media-body">
                  <h4>First Working Process</h4>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
